import javaBackendAxios from "../axios";
import type { AxiosProgressEvent } from "axios";

export const getFilesForCaseId = async (caseId: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/file/case/${caseId}/files`);
        const data = await response.data;
        return data;
    } catch (error) {
        console.error("Błąd podczas pobierania plików:", error);
        throw error;
    }
};
export const createNewDir = async (caseId: string, targetFileId: string, directoryName: string) => {
    try {
        return await javaBackendAxios.post('/api/java/file/create-directory/SOURCE', null, {
            params: {
                caseId: caseId,
                targetFileId: targetFileId,
                directoryName: directoryName
            }
        });
    } catch (error) {
        console.error("Błąd podczas tworzenia nowego folderu:", error);
        throw error;
    }

};
export const deleteFileById = async (fileId: string) => {
    try {
        return javaBackendAxios.delete(`/api/java/file/${fileId}`);
    } catch (error) {
        console.error("Błąd podczas usuwania contentu: ", error);
        throw error;
    }
};
export const uploadFileToServer = (
    caseId: string,
    targetFileId: string,
    file: File,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
  
    return javaBackendAxios.post("/api/java/file/upload/SOURCE", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: { caseId, targetFileId },
      onUploadProgress,
    });
  };